import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AcceptInvite from "@/pages/AcceptInvite";
import ProposalStudio from "@/pages/ProposalStudio";
import PlatformLayout from "@/pages/platform/PlatformLayout";
import Dashboard from "@/pages/platform/Dashboard";
import Ledger from "@/pages/platform/Ledger";
import Inbox from "@/pages/platform/Inbox";
import Distribution from "@/pages/platform/Distribution";
import Replenishment from "@/pages/platform/Replenishment";
import Installations from "@/pages/platform/Installations";
import Returns from "@/pages/platform/Returns";
import Reports from "@/pages/platform/Reports";
import Reconciliation from "@/pages/platform/Reconciliation";
import RegionalHeatmap from "@/pages/platform/RegionalHeatmap";
import Locations from "@/pages/platform/Locations";
import Users from "@/pages/platform/Users";
import ActivityLog from "@/pages/platform/ActivityLog";
import StockMap from "@/pages/platform/StockMap";
import Transfers from "@/pages/platform/Transfers";

const Protected = ({ children }) => {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center bg-[#F4F5F7]"><Loader2 className="h-8 w-8 animate-spin text-[#00857C]" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/proposal" element={<ProposalStudio />} />
            <Route path="/" element={<Protected><PlatformLayout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="ledger" element={<Ledger />} />
              <Route path="inbox" element={<Inbox />} />
              <Route path="distribution" element={<Distribution />} />
              <Route path="transfers" element={<Transfers />} />
              <Route path="replenishment" element={<Replenishment />} />
              <Route path="installations" element={<Installations />} />
              <Route path="returns" element={<Returns />} />
              <Route path="reports" element={<Reports />} />
              <Route path="reconciliation" element={<Reconciliation />} />
              <Route path="regions" element={<RegionalHeatmap />} />
              <Route path="map" element={<StockMap />} />
              <Route path="locations" element={<Locations />} />
              <Route path="users" element={<Users />} />
              <Route path="activity" element={<ActivityLog />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
